// extracted by mini-css-extract-plugin
module.exports = {"topRight":"Icons_topRight__3k1I_","middleIcon":"Icons_middleIcon__2R8hq","icon":"Icons_icon__1Yl5C"};